import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { useEscapeKey } from "../hooks/useEscapeKey";
import React, { useLayoutEffect } from "react";
import { createPortal } from "react-dom";
const LG_MIN_WIDTH_PX = 992;
export default function FilterOverlay({ open, onClose, children, }) {
    useLayoutEffect(() => {
        const closeIfDesktopWidth = () => {
            if (window.innerWidth < LG_MIN_WIDTH_PX)
                return;
            if (!open)
                return;
            onClose();
        };
        closeIfDesktopWidth();
        window.addEventListener("resize", closeIfDesktopWidth);
        return () => window.removeEventListener("resize", closeIfDesktopWidth);
    }, [open, onClose]);
    useEscapeKey(open, onClose);
    useBodyScrollLock(open);
    if (!open)
        return null;
    return createPortal(<div className="fixed inset-0 z-[9999] bg-black/40">
      <button type="button" aria-label="Close filters" className="absolute inset-0 w-full h-full cursor-default" onClick={onClose}/>
      <div className="relative h-full w-full bg-white flex flex-col max-h-full">
        {children}
      </div>
    </div>, document.body);
}
